import { render, staticRenderFns } from "./LammieRequestReader.vue?vue&type=template&id=4b2bdef2"
import script from "./LammieRequestReader.vue?vue&type=script&lang=js"
export * from "./LammieRequestReader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b2bdef2')) {
      api.createRecord('4b2bdef2', component.options)
    } else {
      api.reload('4b2bdef2', component.options)
    }
    module.hot.accept("./LammieRequestReader.vue?vue&type=template&id=4b2bdef2", function () {
      api.rerender('4b2bdef2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/lammie/LammieRequestReader.vue"
export default component.exports